<template>
  
  <div id="app">
    <Home />
    <About />
    <Skills />
    <Portfolio />
    <Contact />
    <Footer />
  </div>
  
</template>

<script>
import Home from "./views/HomeView.vue";
import About from "./views/AboutView.vue";
import Skills from "./views/SkillsView.vue";
import Portfolio from "./views/PortfolioView.vue";
import Contact from "./views/ContactView.vue";
import Footer from "./views/FooterView.vue";

export default {
  name: "App",
  components: {
    Home ,
    About,
    Skills,
    Portfolio,
    Contact,
    Footer
  },
};
</script>

<style lang="scss">
#app{
  height: fit-content;
  overflow-x: hidden;
  overflow-y: hidden;
}
@import "./style/main.css";
</style>